export const SUCCESSFULLY_UPDATED =
  'Information successfully updated';
